module.exports = __webpack_public_path__ + "static/img/9-s.77912cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/9-s.jpg
// module id = vxge
// module chunks = 0